module.exports = __webpack_public_path__ + "img/A63_lottory.c192eaed.webp";